var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowVideo),expression:"isShowVideo"}],style:({opacity: `${_vm.isShowVideo? '1': '0'}`}),attrs:{"id":"wy-player"}},[_c('div',{attrs:{"id":"dplayer"}}),(!_vm.isPC())?_c('div',{staticClass:"dplayer-mobile-play-mask add-like"},[_c('likesMask',{attrs:{"live":_vm.live}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }